export default __webpack_public_path__ + "static/media/cs-c001-Picture1.f2bf93b9.png";